<div [innerHTML]="block.value"></div>
